import styled, { css } from 'styled-components'
import media from 'styles/media'

const inActiveStyle = css`
  opacity: 0.6;
  pointer-events: none;
`
const Wrapper = styled.div<{ $inActive: boolean }>`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  ${({ $inActive }) => $inActive && inActiveStyle}
`

const CouponImage = styled.img`
  flex-shrink: 0;
  object-fit: cover;
  width: 64px;
  height: 36px;
  border-radius: 4px;
`

const CouponDetails = styled.div`
  align-self: start;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing['2XS']};
  flex-grow: 1;
  padding-left: 16px;

  @media (${media.screenSmMiniMax}) {
    padding-left: 8px;
  }
`

const CouponDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const TitleSection = styled.div`
  display: flex;
  align-items: start;
  column-gap: ${({ theme }) => theme.spacing.horizontalSpacingXS};
`

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Condition = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: ${({ theme }) => theme.spacing.horizontalSpacingXS};
`

const Tag = styled.div`
  margin-top: -1px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.red600};
  border-radius: 15px;
  padding: ${({ theme }) => `${theme.spacing.verticalSpacingXXS} ${theme.spacing.verticalSpacingS}`};
`

export {
  Wrapper,
  CouponImage,
  CouponDetailsWrapper,
  CouponDetails,
  Condition,
  FlexContainer,
  TitleSection,
  ColumnContainer,
  Tag,
}
